import axios from 'axios';
import type {
  Comparison,
  CreateComparisonRequest,
  ComparisonItemsActionRequest,
  CreateEventFromDifferenceRequest,
  SearchComparisonItemsQuery,
  SearchTasksResponse,
} from '../../../types/BaselineMeasurements';

const createComparisonFromEvents = async ({
  comparisonId,
  connectionId,
  eventIds,
  selectAll,
}: CreateComparisonRequest) => {
  return axios.post(`/baseline-measurements/comparisons`, {
    comparisonId,
    connectionId,
    eventIds,
    selectAll,
  });
};

const declineComparisonItems = async ({
  comparisonId,
  connectionId,
  itemsIds,
  selectAll,
}: ComparisonItemsActionRequest) => {
  return axios.post(`/baseline-measurements/comparisons/${comparisonId}/items/decline`, {
    comparisonId,
    connectionId,
    itemsIds,
    selectAll,
  });
};

const archiveComparisonItems = async ({
  comparisonId,
  connectionId,
  itemsIds,
  selectAll,
}: ComparisonItemsActionRequest) => {
  return axios.post(`/baseline-measurements/comparisons/${comparisonId}/items/archive`, {
    comparisonId,
    connectionId,
    itemsIds,
    selectAll,
  });
};

const processComparisonItems = async ({
  comparisonId,
  connectionId,
  itemsIds,
  selectAll,
}: ComparisonItemsActionRequest) => {
  return axios.post(`/baseline-measurements/comparisons/${comparisonId}/items/process`, {
    comparisonId,
    connectionId,
    itemsIds,
    selectAll,
  });
};

const getComparison = async (comparisonId: Comparison['comparisonId']) => {
  return axios.get(`/baseline-measurements/comparisons/${comparisonId}`);
};

const countComparisonCompletedByConnectionId = async (connectionId: Comparison['connectionId']) => {
  return axios.get(`/baseline-measurements/comparisons/search/count`, {
    params: {
      connectionId: connectionId,
      status: 'completed',
    },
  });
};

const searchActiveByConnectionId = async (connectionId: Comparison['connectionId']) => {
  return axios.get(`/baseline-measurements/comparisons/search/active`, {
    params: {
      connectionId: connectionId,
    },
  });
};

const completeComparison = async (comparisonId: Comparison['comparisonId']) => {
  return axios.post(`/baseline-measurements/comparisons/${comparisonId}/complete`);
};

const searchComparisonItems = async ({
  comparisonId,
  page,
  pageSize,
  itemType,
  searchQuery,
}: SearchComparisonItemsQuery) => {
  return axios.get(`/baseline-measurements/comparisons/${comparisonId}/items`, {
    params: {
      page,
      pageSize,
      itemType,
      searchQuery,
    },
  });
};

const createEventFromDifferences = async ({
  comparisonId,
  connectionId,
  comparisonItemId,
  newEventType,
}: CreateEventFromDifferenceRequest) => {
  return axios.post(`/baseline-measurements/comparisons/${comparisonId}/events-from-differences`, {
    comparisonId: comparisonId,
    connectionId: connectionId,
    comparisonItemId: comparisonItemId,
    newEventType: newEventType,
  });
};

export const searchComparisonTasks = async (comparisonId: Comparison['comparisonId']) => {
  return axios.get<SearchTasksResponse>(`/baseline-measurements/comparisons/${comparisonId}/tasks`);
};

export const baselineMeasurementService = {
  getComparison,
  completeComparison,
  searchComparisonItems,
  createEventFromDifferences,
  countComparisonCompletedByConnectionId,
  createComparisonFromEvents,
  declineComparisonItems,
  archiveComparisonItems,
  processComparisonItems,
  searchComparisonTasks,
  searchActiveByConnectionId,
};
